import {defineStore} from "pinia";
import api from "@/plugins/axios"

export const useBackupStore = defineStore('backups', {
    state: () => ({
        items: [],
        item: [],
    }),
    actions: {
        async getList(filters) {
            try {
                const {data} = await api.get(`backups`, {params: filters});
                this.items = data;
                return this.items
            } catch (error) {
                console.error(error);
            }
        },
        async run(params) {
            try {
                const {data} = await api.post(`backups/run`, params);
                this.item = data;
                return this.item
            } catch (error) {
                console.error(error);
            }
        },
        async download(backupId) {
            try {
                const response = await api.get(`backups/download/${backupId}`, {
                    responseType: 'blob'
                });

                // Создаём временную ссылку для скачивания
                const blob = new Blob([response.data]);
                const downloadUrl = window.URL.createObjectURL(blob);

                const contentDisposition =
                    response.headers['content-disposition'] ||
                    response.headers['Content-Disposition'];

                let fileName = 'file';
                console.log(response.headers)
                if (contentDisposition) {
                    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    const matches = filenameRegex.exec(contentDisposition);
                    console.log(matches)
                    if (matches != null && matches[1]) {
                        fileName = matches[1].replace(/['"]/g, '');
                    }
                }

                // Создаём и запускаем скрытую ссылку
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();

                // Очистка
                window.URL.revokeObjectURL(downloadUrl);
                document.body.removeChild(link);
            } catch (error) {
                console.error('Ошибка при скачивании файла:', error);
                throw error; // Можно обработать ошибку в компоненте
            }

        }
    }
})
